import { StorageEnum } from '../storage';
import { Brand, Store } from './applicationContext.types';

export const getBrandInfo = (brand?: Brand) => ({
  name: brand?.name ?? '',
  logoUrl: brand?.logo ?? brand?.logoUrl,
});

export const getStoreInfo = (store?: Store) => ({
  name: store?.name ?? '',
  logoUrl: store?.logoUrl,
});

export const isAdminTeceo = () => {
  if (!localStorage.user) {
    return false;
  }

  const user = JSON.parse(localStorage.user);
  return !!user[StorageEnum.ADMIN_TEAM_ID];
};

export const ZINZANE_SLUG = 'zinzaneinternational';

export const OFICINA_RESERVA_SLUG = 'oficinareserva';
